import {backendUrl} from './api/api';

// fetch natif (et non axios) pour beneficier de cache:'no-store' : force le navigateur
// a ne jamais servir cette reponse depuis son cache HTTP. Axios ne supporte pas
// cette option. credentials omitme absolument : endpoint deja public (URLS_PUBLIC).
export const fetchBackendVersion = () =>
    fetch(`${backendUrl}/application/version`, {cache: 'no-store', credentials: 'omit'})
        .then(r => r.json())
        .then(d => d && d.version);